import { createBrowserClient } from '@supabase/ssr'

/**
 * Create a Supabase client for client-side use in browser components
 * This uses @supabase/ssr for proper session management
 * 
 * @returns Supabase client instance for browser use
 */
export function createSupabaseBrowserClient() {
  return createBrowserClient(
    process.env.NEXT_PUBLIC_SUPABASE_URL!,
    process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!
  )
}
